<template>
    <div class="card mr-3 text-center">
        <div>
            <h3>{{ title }}</h3>
        </div>
        <div>
            <h1>{{ value }}</h1>
        </div>
    </div>
</template>
<script>
export default {
    name: "IndicatorSmall",
    props: {
        title: {
            type: String,
            required: true,
            default: () => 'Card title'
        },
        value: {
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {},
}
</script>
<style>
    .card {
        width: auto;
        min-width: 150px;
        padding: 0.75rem;
    }
</style>